import { Injectable } from "@angular/core";
import { CoreLogService } from "../../services/log.service";
import { LikeService } from "../../services/like.service";
import { LikeDataModel, LikeGroupViewModel } from "../../shared/models";
import Utils from "../../shared/utils";
import { environment } from "../../../../environments/environment";
import { ContentType } from "../../shared/contentTypes";

@Injectable()
export class UserLikesService {

  constructor(private _coreLogService: CoreLogService
    , private _likeService: LikeService) { }

  public GetAllLikes(): Promise<LikeGroupViewModel[]> {
    const me = this;
    return new Promise((resolve, reject) => {
      me._likeService.GetAllActiveLikes()
        .then((likes) => {
          resolve(me.mapToLikeViewModelList(likes));
        })
        .catch((error) => {
          me._coreLogService.error("UserLikesService.GetAllLikes", "_likeService.GetAllActiveLikes", error);
          reject();
        });
    });
  }

  private mapToLikeViewModelList(models: LikeDataModel[]): LikeGroupViewModel[] {
    const LikedContentTypes = [];

    // get distinct content type
    const map = new Map();
    for (const item of models) {
      if (!map.has(item.content_type)) {
        map.set(item.content_type, true);    // set any value to Map
        LikedContentTypes.push(item.content_type);
      }
    }
    const likeGroupViewModelList: LikeGroupViewModel[] = [];
    LikedContentTypes.forEach(contentType => {
      const filterliked = models.filter(r => r.content_type === contentType);
      const likeGroupViewModel: LikeGroupViewModel = new LikeGroupViewModel();
      likeGroupViewModel.contentType = contentType;
      likeGroupViewModel.contentkey = Utils.EnumName(ContentType, contentType);
      likeGroupViewModel.count = filterliked.length;
      likeGroupViewModelList.push(likeGroupViewModel);
    });
    return likeGroupViewModelList;
  }
}
